import { el, setChildren } from 'https://cdn.venturz.co/lib/redom.es.js';

import TextInputRenderer from './renderers/text/index.js';
import NumberInputRenderer from './renderers/number/index.js';
import EmailInputRenderer from './renderers/email/index.js';
import TextAreaInputRenderer from './renderers/textarea/index.js';
import SelectInputRenderer from './renderers/select/index.js';
import CheckboxGroupRenderer from './renderers/checkbox-group/index.js';
import RadioButtonGroupRenderer from './renderers/radio-button-group/index.js';
import FileInputRenderer from './renderers/file/index.js';

import fieldTypes from './field-types.js';

const inputRenderers = {
  [fieldTypes.TEXT]: TextInputRenderer,
  [fieldTypes.NUMBER]: NumberInputRenderer,
  [fieldTypes.EMAIL]: EmailInputRenderer,
  [fieldTypes.TEXT_AREA]: TextAreaInputRenderer,
  [fieldTypes.SELECT]: SelectInputRenderer,
  [fieldTypes.CHECKBOX_GROUP]: CheckboxGroupRenderer,
  [fieldTypes.RADIO_BUTTON_GROUP]: RadioButtonGroupRenderer,
  [fieldTypes.FILE]: FileInputRenderer
};

class FormFieldRow {

  constructor(formFieldRenderer) {

    this.index = null;
    this.fieldRow = null;
    this.inputRenderer = null;
    this.formFieldRenderer = formFieldRenderer;

    this.label = null;

    this.el = el('.form-editor-field-row-main', [
      el('.form-editor-field-row-auto-elements', [
        el('.form-editor-field-label-row', [
          this.renderLabel()
        ]),
        this.renderInputContainer()
      ])
    ]);

  }

  renderLabel() {

    this.label = el('label.form-editor-field-row-label', {
      class: 'field-label'
    });

    return this.label;

  }

  renderInputContainer() {

    this.inputContainer = el('div.form-editor-field-row-input-container');

    return this.inputContainer;

  }

  updateLabel() {

    this.label.textContent = this.fieldRow.label;

  }

  updateInput() {

    let inputRenderer = this.inputRenderer;
    const InputRenderer = inputRenderers[this.fieldRow.type];

    if ((inputRenderer instanceof InputRenderer) === false) {

      const configuration = {
        formId: this.formFieldRenderer.formId,
        page: this.formFieldRenderer.page
      };

      inputRenderer = this.inputRenderer = new InputRenderer(configuration);
      setChildren(this.inputContainer, [inputRenderer]);
    }

    inputRenderer.update(this.fieldRow.options, this.fieldRow);

  }

  update(fieldRow, index) {

    this.fieldRow = fieldRow;
    this.index = index;

    this.updateLabel();
    this.updateInput();

  }

}

export default FormFieldRow;